import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy, Output, EventEmitter, OnChanges } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ListOption } from '../form-field-wrapper/form-field-wrapper.component';
import { Subscription } from "rxjs";
declare var $: any;

export interface DropdownListOption {
  id: number;
  name: string;
  value: string;
  order?: number;
  selected?: boolean;
  disabled?: boolean;
}

export interface IListOption extends ListOption {
  name?: string; // display value
}

@Component({
    selector: 'app-search-dropdown',
    templateUrl: './search-dropdown.component.html',
    styleUrls: ['./search-dropdown.component.scss'],
    standalone: false
})
export class SearchDropdownComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() unicodeIcon?: string;
  @Input() placeholder: string;
  @Input()
  get listOptions(): IListOption[] { return this._listOptions; }
  set listOptions(listOptions: IListOption[]) { this._listOptions = listOptions; }
  private _listOptions = [];

  @Output() selectedItem: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dropDown') dropDown: ElementRef; // the semantic-ui dropdown
  dropdown: any;

  subscriptions: Subscription[] = [];

  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit() {
    this.fillDropdownWithOptions();
    this.ref.detectChanges();
  }

  ngOnChanges() {
    this.fillDropdownWithOptions();
  }

  fillDropdownWithOptions() {
    if (!this.dropDown) {
      return;
    }
    const valueOptions: DropdownListOption[] = this.listOptions
      .map((item: IListOption) => ({
        id: item.id,
        name: item.name || item.display,
        value: item.value,
        selected: item.value === this.formCtrl.value,
        order: item.order,
        disabled: item.disabled
      })).sort((a, b) => a.order - b.order);


    // init semantic-ui dropdown
    this.dropdown = $(this.dropDown.nativeElement).dropdown({
      values: valueOptions,
      placeholder: this.placeholder,
      fullTextSearch: "exact",
      preserveHTML: false,
      onChange: (selected?: string) => {
        if (selected) {
          const itemFromList = this.listOptions.find(item => String(item.value) === String(selected));
          if (this.formCtrl.value !== itemFromList) {
            this.formCtrl.setValue(itemFromList);
            this.selectedItem.emit(itemFromList);
          }
        }
      }
    });

    this.dropdown.dropdown('set selected', this.formCtrl.value);

    this.subscriptions.push(this.formCtrl.valueChanges.subscribe(value => {
      // when the form control is updated elsewhere, update the dropdown to reflect the new value
      if (value && value.value) {
        this.dropdown.dropdown('set selected', value.value);
      }
    }));
  }

  updateListOptions(valueOptions: DropdownListOption[]) {
    this.dropdown.dropdown('change values', valueOptions);
  }

  clearSelection() {
    this.dropdown.dropdown('clear');
  }

  setSelected(value: any) {
    this.dropdown.dropdown('set selected', value);
  }

}
